export default __webpack_public_path__ + "static/media/632.cfda5ccb.png";